import React from 'react';
import { solscanUrl } from '../utils/formatting';
import { OpenLink } from './OpenLink';

export function AccountLink({account}: {account: string}) {
    return (
	<a className="value open-new-window-icon" href={solscanUrl({account})} target="_blank">
	    {account.slice(0, 10)}...
	    <OpenLink />
	</a>
    );
}

